var React = require('react');

function Blob (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M374 341.253C339.148 327.961 305.138 314.069 274.394 304.339C180.968 274.773 117.108 283.052 45.5603 255.259C30.4619 249.519 15.084 242.146 5.76914e-05 233.269C-9.48965e-05 145 0.000103468 -2 0.000103468 -2C106 -1.99999 242 -1.99999 374 -1.99999V341.253Z"}));
}

Blob.defaultProps = {"viewBox":"0 0 374 342","fill":"none"};

module.exports = Blob;

Blob.default = Blob;
